'use strict';

var cov_jj2dgt2av = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/projectSelector/projectSelector.js',
        hash = '660df78c25c978fd994749c98ad899290301d858',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/projectSelector/projectSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 9
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 12
                },
                end: {
                    line: 4,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 37
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 48
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }, {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }],
                line: 3
            },
            '1': {
                loc: {
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                }, {
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                }],
                line: 6
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectSelectorController = function () {
    function ProjectSelectorController() {
        _classCallCheck(this, ProjectSelectorController);
    }

    _createClass(ProjectSelectorController, [{
        key: 'changed',
        value: function changed() {
            cov_jj2dgt2av.f[0]++;
            cov_jj2dgt2av.s[0]++;

            if (this.ngModel == 'null') {
                cov_jj2dgt2av.b[0][0]++;
                cov_jj2dgt2av.s[1]++;

                this.ngModel = null;
            } else {
                cov_jj2dgt2av.b[0][1]++;
            }
            cov_jj2dgt2av.s[2]++;
            if (this.ngModel == '') {
                cov_jj2dgt2av.b[1][0]++;
                cov_jj2dgt2av.s[3]++;

                this.ngModel = undefined;
            } else {
                cov_jj2dgt2av.b[1][1]++;
            }
            cov_jj2dgt2av.s[4]++;
            this.ngChange({ $project: this.ngModel });
        }
    }]);

    return ProjectSelectorController;
}();

cov_jj2dgt2av.s[5]++;


angular.module('app').component('projectSelector', {
    templateUrl: 'app/components/projectSelector/projectSelector.html',
    controller: ProjectSelectorController,
    bindings: {
        ngChange: '&',
        ngModel: '='
    }
});